// import store from "../../../store/index";

export const FhsAuthInterceptors = {
  onRequest: config => {
    return config;
  },
  onResponse: response => {
    return Promise.resolve(response);
  },
  onError: error => {
    return Promise.reject(error);
  }
};
